import WithdrawScreen from "./components/WithdrawScreen";

export default function WithdrawPage() {
  return <WithdrawScreen />;
}
